import InputField from "@medoma/components/InputField/InputField";
import styles from "./SearchPanel.module.scss";
import { InlineAlert } from "@medoma/components/InlineAlert/InlineAlert";
import { useSearchField } from "@medoma/components/SearchField/useSearchField";
import { useLingui } from "@lingui/react/macro";

export const SearchPanel = () => {
  const { t } = useLingui();
  const { value, onChange, currentFilter, clear } = useSearchField();

  return (
    <>
      <search className={styles.searchPanel}>
        <InputField
          outerWidth="fit"
          type="search"
          name="search"
          label={t`Sök patient`}
          showOptionalLabel={false}
          {...{ value, onChange }}
        />
      </search>
      {currentFilter ? (
        <InlineAlert
          type="info"
          title={t`Sökt på patientnamn "${currentFilter}"`}
          placement="fill"
          hideIcon
          actions={[
            {
              label: t`Rensa`,
              onClick: clear,
            },
          ]}
        />
      ) : null}
    </>
  );
};
